<div class="layout-wrapper" [ngClass]="containerClass">
	<div class="layout-sidebar">
		<app-sidebar></app-sidebar>
	</div>

	<div class="layout-main-container">
		<app-topbar></app-topbar>
		<div class="layout-content">
			<app-breadcrumb></app-breadcrumb>
			<div class="layout-main">
				<router-outlet></router-outlet>
			</div>
		</div>
	</div>
	<div class="layout-mask"></div>
</div>

<div class="spinner-mask" [ngClass]="{ 'spinner-mask': isSpinnerActive }">
	<app-progress-spinner *ngIf="isSpinnerActive" class="spinner"></app-progress-spinner>
</div>
